import {IdObjectsWithId} from "../../utils";
import {IFileData} from "./filedata/types";

export enum FileType {
    FOLDER,
    FILE
}

export interface IFile {
    id: string;
    type: FileType;
    name: string;
    path: string;
    parentPath?: string;
    fileDataId?: string;
    parentId?: string;
    children?: string[];
    created: Object;
    updated: Object;
    createdBy: string,
    updatedBy: string,
}

export interface IFileWithData extends IFile {
    activeFileData?: IFileData
    readonly?: boolean
}

export interface ICheckedFileIds {
    folderIds: string[];
    fileIds: string[];
}

export interface IFileSystemState {
    readonly files: IdObjectsWithId<IFile>;
    readonly filesData: IdObjectsWithId<IFileData>
    readonly isFilesLoading: boolean;
    readonly isSavingFileData: boolean;
    readonly selectedFileId: string;
    readonly checkedFileIds: ICheckedFileIds;
    readonly activeFileData?: IFileData;
}